export default __webpack_public_path__ + "static/media/fuerza_vital.dc8f5436.jpg";